import { FORMAT, formatDate } from '../../../lib/date';
import { ReactComponent as DishSvg } from '../../../assets/svg/dish.svg';

const RecentMeal = ({
  openFeedDialog,
  openViewDialog,
  prevMeals,
  lastMealInfo,
  setIsIngredientDialogOpen,
}) => {
  const handleOpenViewDialog = () => {
    openViewDialog();
    setIsIngredientDialogOpen(true);
  };

  return (
    <div>
      {prevMeals.some((meal) => meal !== null) && (
        <div className='grid grid-cols-3 gap-2 mb-2'>
          {prevMeals.map((meal, i) =>
            !!meal ? (
              <div
                key={meal.id}
                className='relative text-xs border border-tertiary rounded-xl overflow-hidden'
              >
                <img
                  src={meal.photoUrl}
                  alt='previous-meal'
                  className='object-cover aspect-square'
                  onClick={openFeedDialog}
                />
                <div className='absolute top-1 left-1 bg-black bg-opacity-60 text-white rounded-full px-1'>
                  {meal.logDate === formatDate(new Date(), FORMAT.DATE)
                    ? 'Today'
                    : meal.logDate}
                </div>
                {meal.calorie && (
                  <div className='absolute bottom-0 right-0 bg-tertiary text-white rounded-tl-xl rounded-br-xl px-1 text-xs font-bold'>
                    {meal.calorie} Cal
                  </div>
                )}
              </div>
            ) : (
              <div
                key={`key-${i}`}
                className='aspect-square flex justify-center items-center border border-tertiary rounded-xl text-white'
              >
                <DishSvg className='size-10 opacity-10' />
              </div>
            )
          )}
        </div>
      )}
      {lastMealInfo?.photoUrl ? (
        <div className='relative text-xs aspect-square flex justify-center border border-tertiary rounded-xl overflow-hidden'>
          <img
            src={lastMealInfo.photoUrl}
            alt='last-meal'
            className='object-cover w-full'
            onClick={handleOpenViewDialog}
          />
          <div className='absolute top-1 left-1 bg-black bg-opacity-60 text-white rounded-full px-1'>
            {formatDate(new Date(lastMealInfo.consumedAt), FORMAT.DATE) ===
            formatDate(new Date(), FORMAT.DATE)
              ? 'Today'
              : formatDate(new Date(lastMealInfo.consumedAt), FORMAT.DATE)}
          </div>
          <div className='absolute top-1 right-1 bg-black bg-opacity-60 text-white rounded-full px-1'>
            {formatDate(new Date(lastMealInfo.consumedAt), FORMAT.HOURMIN)}
          </div>
          {lastMealInfo.calorie && (
            <div className='absolute -bottom-[1px] right-0 bg-tertiary text-white rounded-tl-xl rounded-br-xl px-2 text-sm font-bold'>
              {lastMealInfo.calorie} Cal
            </div>
          )}
          {lastMealInfo.tags.length > 0 && (
            <div className='absolute -bottom-[1px] left-0 bg-tertiary text-white px-2 text-sm rounded-tr-xl rounded-bl-xl'>
              {lastMealInfo.tags.map((tag) => `#${tag.tag.name}`).join(' ')}
            </div>
          )}
        </div>
      ) : (
        <div className='border border-tertiary rounded-xl flex flex-col justify-center items-center aspect-square text-white'>
          <DishSvg className='size-20 opacity-10' />
          <p className='opacity-20'>No meals</p>
        </div>
      )}
    </div>
  );
};

export default RecentMeal;
